// export const base_url = "https://my-json-server.typicode.com/sakars1/typicode/";
export const base_url = process.env.REACT_APP_BASE_URL
export const BASE_URL = process.env.REACT_APP_BASE_URL